module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_makati-021b13ac33d01abc6e2c24c21069d120.png";